module.exports = __webpack_public_path__ + "img/bg17.9aa5c63f.png";